import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { withDefaultStyles } from '../utils/material-ui/hoc';

class GlobalSearch extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Select
          placeholder='Global Search'
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}


export default withDefaultStyles(connect(
  mapStateToProps,
)(GlobalSearch));



// WEBPACK FOOTER //
// ./src/components/global-search.tsx